// @docs https://[domain]/api/v1/docs
export default {
  List: "pyr/group-employees",
  Detail: "pyr/group-employees",
  Update: "pyr/group-employees",
  Create: "pyr/group-employees",
  Delete: "pyr/group-employees",
  ListShort: "pyr/group-employees/short",

  ListEmployee: "pyr/group-employee/employees",
  AddEmployee: "pyr/group-employee/add-employees",
  RemoveEmployee: "pyr/group-employee/remove-employees",

  ListRole: "pyr/group-employee/roles",
  AddRole: "pyr/group-employee/add-roles",
  RemoveRole: "pyr/group-employee/remove-roles",
};
